module.exports = __webpack_public_path__ + "static/media/icoCheck.7417cdd7.svg";